export default __webpack_public_path__ + "static/azure-676d7cf33aa2732e7f971bdec02b17b0.svg";